var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgRent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 93,
    viewBox: "0 0 94 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 16H83V87H11V16Z",
    fill: "#FFEADB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 37C21 36.4477 21.4477 36 22 36H72C72.5523 36 73 36.4477 73 37V38C73 38.5523 72.5523 39 72 39H22C21.4477 39 21 38.5523 21 38V37Z",
    fill: "#FF9D5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 44C21 43.4477 21.4477 43 22 43H72C72.5523 43 73 43.4477 73 44V45C73 45.5523 72.5523 46 72 46H22C21.4477 46 21 45.5523 21 45V44Z",
    fill: "#FF9D5A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 51C21 50.4477 21.4477 50 22 50H72C72.5523 50 73 50.4477 73 51V52C73 52.5523 72.5523 53 72 53H22C21.4477 53 21 52.5523 21 52V51Z",
    fill: "#FF9D5A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0212 91.0667H32.9805V69.0046C32.9805 66.6107 34.9213 64.6699 37.3151 64.6699H56.6866C59.0804 64.6699 61.0205 66.6107 61.0205 69.0046V91.0667H61.0212Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4082 64.6699H48.5922V91.0667H45.4082V64.6699Z",
    fill: "#EF7C00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 89C0 87.8954 0.895431 87 2 87H91.75C92.8546 87 93.75 87.8954 93.75 89V90.93C93.75 92.0346 92.8546 92.93 91.75 92.93H2C0.895431 92.93 0 92.0346 0 90.93V89Z",
    fill: "#4B4A50"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14C5 12.8954 5.89543 12 7 12H86.75C87.8546 12 88.75 12.8954 88.75 14V15.93C88.75 17.0346 87.8546 17.93 86.75 17.93H7C5.89543 17.93 5 17.0346 5 15.93V14Z",
    fill: "#EF7C00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgRent);
export default __webpack_public_path__ + "static/media/imgRent.f008c49d983f91cc6909107a0fde9711.svg";
export { ForwardRef as ReactComponent };